// @flow
import React from 'react';
import styles from './masterData.scss';
import CellsList from '../../../commons/cellView/cellsList';
import { zoomTableActionsConfig } from '../../../commons/zoomTable/zoomTableConfig';
import { RenderTableActionButtons } from '../../../commons/tableActionButton/tableActionButton';

export const pageObj = {
  pageName: 'SHOP FLOOR MANAGEMENT',
  betaPage: false
};

export const shopfloorPermissions = {
  ROLE_ENABLE_DISABLE_SHOP_FLOOR: 'ROLE_ENABLE_DISABLE_SHOP_FLOOR'
};

const editImg = require('../../../../assets/images/ic_mode_edit_black_24px.svg');
const deleteImg = require('../../../../assets/images/ic_delete_black_24px.svg');

export const getSelectedCells = (row: Object) => {
  const filteredCells = row.cells.filter(
    cell => cell.cellStatus === 'AVAILABLE'
  );
  const function1 = (map, cell) => {
    map[cell.name] = cell;
    return map;
  };
  let selectedCellsList = filteredCells.reduce(function1, {});
  if (selectedCellsList == null) selectedCellsList = {};
  return selectedCellsList;
};

export const manageShopfloorRouteObj = {
  route: '/managelane',
  zoomuinewroute: true
};

export const masterDataButtonConfig = {
  buttons: [
    {
      // Edit button
      iconRef: editImg,
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Edit clicked row {} ', rowData);
        if (
          zoomTableActionsConfig.MASTER_DATA.actions &&
          zoomTableActionsConfig.MASTER_DATA.actions.editCellPrefix
        ) {
          zoomTableActionsConfig.MASTER_DATA.actions.editCellPrefix(rowData);
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '20%',
        height: '50%',
        margin: '5%'
      }
    },
    {
      // delete button
      iconRef: deleteImg,
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Delete clicked ', rowData);
        if (
          zoomTableActionsConfig.MASTER_DATA.actions &&
          zoomTableActionsConfig.MASTER_DATA.actions.deleteCellPrefix
        ) {
          zoomTableActionsConfig.MASTER_DATA.actions.deleteCellPrefix(rowData);
        }
      },
      style: {
        width: '20%',
        height: '50%',
        margin: '5%'
      }
    }
  ]
};

export const masterDataTableConfig = {
  columns: [
    {
      Header: 'Define Prefix',
      headerClassName: 'flex-20',
      className: 'flex-20',
      accessor: 'prefix',
      Cell: (row: Object) => (
        <div>
          <div className={styles.cellList}> {row.original.prefix}</div>
        </div>
      )
    },
    {
      Header: 'Number of Cells',
      headerClassName: 'flex-20',
      className: 'flex-20',
      accessor: 'noOfCells',
      Cell: (row: Object) => row.original.noOfCells
    },
    {
      Header: 'Active/Inactive Cells',
      headerClassName: 'flex-50',
      className: 'flex-50',
      accessor: 'cells',
      Cell: (row: Object) => (
        <div className="float-left">
          <CellsList
            key={row.original.prefix}
            prefix={row.original.prefix}
            selectedCells={getSelectedCells(row.original)}
            availableCells={row.original.cells}
            cellUlClassName={styles.cellUl}
            cellListClassName={styles.cellList}
            cellListBlockedClassName={styles.cellListBlocked}
          />
        </div>
      )
    },
    {
      Header: 'Action',
      headerClassName: 'flex-10',
      className: 'flex-10',
      Cell: (row: Object) => (
        <RenderTableActionButtons
          buttonConfig={masterDataButtonConfig.buttons}
          rowData={row.original || {}}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No data found',
  minRows: 0,
  style: { maxHeight: 'calc(100vh - 22rem)' }
};
